import { createSlice } from "@reduxjs/toolkit";

const initialData = {
  sideNavFlag: false,
  columnData: {
    columns: [],
    reference_columns: [],
    key_reference_columns: [],
    editable_columns: [],
    restricted_columns: [],
    tag_columns: [],
  },
  pageSize: 20,
  dashboardData: {
    kpi: [],
    team_performance_chart: [],
    active_upc: [],
    active_submission: [],
    review_teams: [],
  },
};

const brainSlice = createSlice({
  name: "brain",
  initialState: initialData,
  reducers: {
    updateSideNavFlag(state, action) {
      state.sideNavFlag = action.payload;
    },
    updateReviewColumnData(state, action) {
      state.columnData = { ...state.columnData, ...action.payload };
    },
    updatePageSize(state, action) {
      state.pageSize = action.payload;
    },
    updateDashboardData(state, action) {
      state.dashboardData = { ...state.dashboardData, ...action.payload };
    },
  },
});

export const {
  updateSideNavFlag,
  updateReviewColumnData,
  updatePageSize,
  updateDashboardData,
} = brainSlice.actions;

export default brainSlice.reducer;
